// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner__5OoXH","sk-bouncedelay":"sk-bouncedelay__1oLDp","bounce1":"bounce1__5meJi","bounce2":"bounce2__1tHiO"};